import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementCheckboxes } from '@uncinc/react-searchkit';

import SearchFacets from '../../Search/Facets';

const SearchTeamFacets: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchTeam__Facets');

  return (
    <SearchFacets className={classNames}>
      <SearchFacetRefinementCheckboxes
        attribute="team"
        title={t('components.search.facets.field_team.label')}
        sortBy={['name:asc']}
        showMore
        includeFieldSet
      />
    </SearchFacets>
  );
};

export default SearchTeamFacets;
